$spacing-bottom: var(--cwc-to-top-button-spacing-bottom, 1.5rem) !default;
$spacing-right: var(--cwc-to-top-button-spacing-right, 1.5rem) !default;
$hover-shift-offset: var(--cwc-to-top-button-hover-shift-offset, 0.1rem) !default;
$transition-duration: var(--cwc-to-top-button-transition-duration, 0.0125s) !default;
$z-index: var(--cwc-to-top-button-z-index, 0) !default;

:host {
  position: fixed;
  z-index: $z-index;
  right: $spacing-right;
  bottom: $spacing-bottom;
}

:host(:hover) {
  right: calc(#{$spacing-right} - #{$hover-shift-offset});
  bottom: calc(#{$spacing-bottom} - #{$hover-shift-offset});
  transition: all $transition-duration;
}
